export default "__VITE_ASSET__gaZ3DhgI__"